import { useQuery } from '@apollo/client';
import { useEffect, useMemo, useState } from 'react';
import { LISTSEASONS } from '../apollo/queries/listSeasons';
import { activeFiltersActions, useActiveFilters } from '../context/active-filter-context';
import { IListSeasons, SEASONS_STATUS } from '../graphql-types/listSeasons';

const useListSeasons = () => {
  const { state, dispatch } = useActiveFilters();
  const [isActiveSeason, setIsActiveSeason] = useState<boolean>();
  const seasonYear = useMemo(
    () => state.season?.label?.split('-')[0] ?? null,
    [state.season?.label]
  );

  const {
    data: seasonsData,
    loading: seasonsLoading,
    error: seasonsError
  } = useQuery(LISTSEASONS, {
    onCompleted({ listSeasons }) {
      const seasonItem = sessionStorage?.getItem('season');
      const seasonStorageValue = seasonItem && JSON.parse(seasonItem);
      const activeSeason = listSeasons?.find(
        (season: IListSeasons) => season.status === SEASONS_STATUS.ACTIVE
      );

      const defaultValue = {
        value: activeSeason?.id ?? '',
        label: activeSeason?.name ?? 'No seasons available'
      };

      dispatch(
        activeFiltersActions.setSeason(
          sessionStorage.getItem('season') === null ? defaultValue : seasonStorageValue
        )
      );
    }
  });

  useEffect(() => {
    setIsActiveSeason(
      seasonsData?.listSeasons?.find((season: IListSeasons) => state?.season.value === season?.id)
        ?.status === SEASONS_STATUS.ACTIVE
    );
  }, [seasonsData?.listSeasons, state?.season.value]);

  return { seasonsData, seasonsLoading, seasonsError, isActiveSeason, seasonYear };
};

export default useListSeasons;
